module.exports = {"id":"207441","name":"Luciano Vietto","rating":"79","photo":"./data/images/photos/1/207441.png","club":{"name":"Valence CF","logo":"./data/images/clubs/ValenceCF.png"},"positions":["BU","AD","MOC","ATT"],"photoFolderIndex":1}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/LucianoVietto0.json
// module id = 2598
// module chunks = 0